import DOMPurify from 'dompurify';

/**
 * Sanitize an untrusted HTML string before rendering via dangerouslySetInnerHTML.
 *
 * Vehicle descriptions (and similar content) can originate from external inventory
 * feeds (e.g. CarsForSale) or dealer input, so they must be treated as untrusted.
 * DOMPurify strips scripts and event handlers while preserving safe formatting,
 * closing the stored-XSS vector flagged by semgrep (react-dangerouslysetinnerhtml).
 */
export function sanitizeHtml(html: string | null | undefined): string {
  if (!html) return '';
  return DOMPurify.sanitize(html);
}
